import { RangeModifier } from '@wheely/ui-kit';
import endOfWeek from 'date-fns/endOfWeek';
import { useCallback, useContext } from 'react';

import { LocalizedWeekPicker } from '@/shared/view/LocalizedWeekPicker';

import { WeekSelectorContext } from './WeekSelector';

interface Props {
  week: RangeModifier;
  onWeekChange: (week: RangeModifier) => void;
}

const WeekPicker = ({ week, onWeekChange }: Props) => {
  const lastValidDay = endOfWeek(new Date(), { weekStartsOn: 1 });

  const { closePopover } = useContext(WeekSelectorContext);

  const handleWeekChange = useCallback(
    (days: RangeModifier) => {
      onWeekChange(days);
      closePopover();
    },
    [onWeekChange, closePopover],
  );

  return (
    <LocalizedWeekPicker
      value={week}
      onWeekChange={handleWeekChange}
      toMonth={new Date()}
      disabledDays={{
        after: lastValidDay,
      }}
    />
  );
};

export { WeekPicker };
